var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sui-input',{attrs:{"type":_vm.currentValue.inputType,"value":_vm.currentValue.value},on:{"input":function($event){return _vm.$emit('updateValue', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }